import React from 'react';
import logo from './logo.svg';
import './App.css';
import { NavRouter } from './NavRouter';

function App() {
  return (
    <div className="App">
      <NavRouter />
    </div>
  );
}

export default App;
